import styled, { CreateStyled } from '../../node_modules/@emotion/styled';

export const theme = {
  /* TODO */
};

export default styled as CreateStyled<typeof theme>;
